import { BANK_FS_BODY, BANK_FS_META, BANK_TEXT_2 } from "@hakili/ui";
import type { ReactNode } from "react";

/** The Politique's two building blocks, shared by the screen and by its first-policy form (`politique-premiere.tsx`). */

/** D2's `.prow`: the rule's name and its small line, the control, the level chip. */
export function RuleRow(props: {
  readonly label: string;
  readonly sub?: string;
  readonly subTestId?: string;
  readonly subTitle?: string;
  /** A long sentence is a sentence (14 px); a short note under a name is metadata (13 px). */
  readonly longSub?: boolean;
  readonly control?: ReactNode;
  readonly level?: ReactNode;
  readonly muted?: boolean;
}): React.JSX.Element {
  return (
    <div className="grid grid-cols-[minmax(0,1.3fr)_auto_auto] items-center gap-3.5 border-t border-gray-100 py-3 first:border-t-0">
      <div>
        <b
          className={`block text-sm font-semibold ${props.muted === true ? "text-gray-500" : "text-gray-900"}`}
        >
          {props.label}
        </b>
        {props.sub === undefined ? null : props.longSub === true ? (
          <small data-testid={props.subTestId} className={`mt-0.5 block ${BANK_FS_BODY} ${BANK_TEXT_2}`}>
            {props.sub}
          </small>
        ) : (
          <small
            data-testid={props.subTestId}
            title={props.subTitle}
            data-meta
            className={`block ${BANK_FS_META} text-gray-600`}
          >
            {props.sub}
          </small>
        )}
      </div>
      <div className="flex items-center justify-end gap-2">{props.control}</div>
      <div className="flex min-w-0 justify-end">{props.level}</div>
    </div>
  );
}

/** D2's `.card`: the title and its small line on one baseline, then the rows. */
export function PolicyCard(props: {
  readonly testId: string;
  readonly title: string;
  readonly sub: string;
  readonly children: ReactNode;
}): React.JSX.Element {
  return (
    <section
      className="rounded-2xl border border-gray-200 bg-white px-5 pb-4 pt-4"
      data-testid={props.testId}
    >
      <div className="mb-1 flex flex-wrap items-baseline gap-x-3 gap-y-1">
        <h2 className="m-0 text-base font-semibold">{props.title}</h2>
        <p className={`m-0 ${BANK_FS_BODY} ${BANK_TEXT_2}`}>{props.sub}</p>
      </div>
      {props.children}
    </section>
  );
}
